import { render, staticRenderFns } from "./SollAcademyTrilhas.vue?vue&type=template&id=3c06f5ec&scoped=true"
import script from "./SollAcademyTrilhas.vue?vue&type=script&lang=js"
export * from "./SollAcademyTrilhas.vue?vue&type=script&lang=js"
import style0 from "./SollAcademyTrilhas.vue?vue&type=style&index=0&id=3c06f5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06f5ec",
  null
  
)

export default component.exports